import React, { useState } from "react";
import { TRANSACTION_TYPES } from "../utils/constants";
import TransactionDetails from "./TransactionDetails";
import ReportSummary from "./ReportSummary";

const TableHeader = () => (
  <tr>
    <th 
      className="text-white fw-semibold" 
      style={{ 
        backgroundColor: "#83c14a",
        padding: "16px 20px",
        fontSize: "0.875rem",
        letterSpacing: "0.5px",
        borderBottom: "none",
      }}
    >
      <i className="bi bi-shop me-2"></i>
      STORE
    </th>
    <th 
      className="text-white fw-semibold text-end" 
      style={{ 
        backgroundColor: "#83c14a",
        padding: "16px 20px",
        fontSize: "0.875rem",
        letterSpacing: "0.5px",
        borderBottom: "none",
      }}
    >
      <i className="bi bi-currency-dollar me-2"></i>
      TOTAL AMOUNT
    </th>
    <th 
      className="text-white fw-semibold text-end" 
      style={{ 
        backgroundColor: "#83c14a",
        padding: "16px 20px",
        fontSize: "0.875rem",
        letterSpacing: "0.5px",
        borderBottom: "none",
      }}
    >
      <i className="bi bi-hash me-2"></i>
      TOTAL COUNT
    </th>
  </tr>
);

const ReportTable = ({ aggregatedData, totals, voidTotals }) => {
  console.log("aggregatedData", aggregatedData);
  const [selectedStore, setSelectedStore] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const currencyFormatter = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const calculateTotals = (storeData) => {
    const totalNet = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.netSale || 0),
      0
    );
    const totalNetSales = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.netSale || 0),
      0
    );
    const totalCount = TRANSACTION_TYPES.reduce(
      (acc, type) => acc + (storeData[type]?.tc || 0),
      0
    );
    return { totalNet, totalCount };
  };

  const handleRowClick = (store, storeData) => {
    setSelectedStore({ name: store, data: storeData });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStore(null);
  };

  // 1) Get entries, 2) sort by store name (the key), 3) map over them
  const sortedEntries = Object.entries(aggregatedData).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  return (
    <>
      <div style={{ 
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #E5E7EB",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}>
        <table className="table table-hover mb-0">
          <thead>
            <TableHeader />
          </thead>

          <tbody>
            {sortedEntries.map(([store, storeData]) => {
              const { totalNet, totalCount } = calculateTotals(storeData);

              return (
                <tr
                  key={store}
                  onClick={() => handleRowClick(store, storeData)}
                  style={{ 
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#F9FAFB";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <td style={{ 
                    padding: "16px 20px",
                    verticalAlign: "middle",
                    borderBottom: "1px solid #E5E7EB",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <i 
                        className="bi bi-chevron-right"
                        style={{ 
                          color: "#83c14a",
                          fontSize: "0.875rem",
                        }}
                      ></i>
                      <span style={{ fontWeight: "600", color: "#111827", fontSize: "0.9375rem" }}>
                        {store}
                      </span>
                    </div>
                  </td>
                  <td style={{ 
                    padding: "16px 20px",
                    verticalAlign: "middle",
                    textAlign: "right",
                    fontWeight: "600",
                    color: "#059669",
                    fontSize: "0.9375rem",
                    borderBottom: "1px solid #E5E7EB",
                  }}>
                    {currencyFormatter.format(totalNet)}
                  </td>
                  <td style={{ 
                    padding: "16px 20px",
                    verticalAlign: "middle",
                    textAlign: "right",
                    fontWeight: "600",
                    color: "#6B7280",
                    fontSize: "0.9375rem",
                    borderBottom: "1px solid #E5E7EB",
                  }}>
                    {totalCount.toLocaleString()}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showModal && selectedStore && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
            padding: "20px",
          }}
          onClick={handleCloseModal}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              maxWidth: "1200px",
              width: "100%",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              animation: "modalFadeIn 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
                padding: "20px 24px",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h5
                style={{
                  color: "#fff",
                  fontSize: "1.25rem",
                  fontWeight: "700",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <i className="bi bi-shop"></i>
                {selectedStore.name}
              </h5>
              <button
                onClick={handleCloseModal}
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  borderRadius: "8px",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                }}
              >
                <i className="bi bi-x-lg" style={{ color: "#fff", fontSize: "1.25rem" }}></i>
              </button>
            </div>

            <div
              style={{
                padding: "24px",
                overflowY: "auto",
                flex: 1,
              }}
            >
              <TransactionDetails
                storeData={selectedStore.data}
                totalNet={calculateTotals(selectedStore.data).totalNet}
                totals={totals}
                voidTotals={voidTotals}
              />

              <div
                style={{
                  marginTop: "24px",
                  background: "#F9FAFB",
                  borderRadius: "12px",
                  padding: "24px",
                  border: "1px solid #E5E7EB",
                }}
              >
                <h6
                  style={{
                    color: "#111827",
                    fontSize: "1rem",
                    fontWeight: "700",
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="bi bi-calculator" style={{ color: "#83c14a" }}></i>
                  Financial Summary
                </h6>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div
                      style={{
                        padding: "16px 20px",
                        background: "#F0FDF4",
                        borderRadius: "10px",
                        border: "1px solid #BBF7D0",
                      }}
                    >
                      <div style={{ fontSize: "0.8125rem", color: "#15803D", fontWeight: "600", marginBottom: "6px" }}>
                        NET SALES
                      </div>
                      <div style={{ fontSize: "1.375rem", fontWeight: "700", color: "#166534" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalNetSales || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      style={{
                        padding: "16px 20px",
                        background: "#EFF6FF",
                        borderRadius: "10px",
                        border: "1px solid #BFDBFE",
                      }}
                    >
                      <div style={{ fontSize: "0.8125rem", color: "#1E40AF", fontWeight: "600", marginBottom: "6px" }}>
                        GROSS SALES
                      </div>
                      <div style={{ fontSize: "1.375rem", fontWeight: "700", color: "#1E3A8A" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalGrossSales || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{ padding: "12px 16px", background: "#FFFFFF", borderRadius: "10px", border: "1px solid #E5E7EB" }}>
                      <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600" }}>Pretax</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#111827" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalPretax || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{ padding: "12px 16px", background: "#FFFFFF", borderRadius: "10px", border: "1px solid #E5E7EB" }}>
                      <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600" }}>Tax</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#111827" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalTax || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div style={{ padding: "12px 16px", background: "#FFFFFF", borderRadius: "10px", border: "1px solid #E5E7EB" }}>
                      <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600" }}>Tax Free</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#111827" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalTaxFree || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      style={{
                        padding: "12px 16px",
                        background: "#FEF3C7",
                        borderRadius: "10px",
                        border: "1px solid #FDE68A",
                      }}
                    >
                      <div style={{ fontSize: "0.75rem", color: "#92400E", fontWeight: "600" }}>Discount</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#78350F" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalDiscount || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      style={{
                        padding: "12px 16px",
                        background: "#FEE2E2",
                        borderRadius: "10px",
                        border: "1px solid #FECACA",
                      }}
                    >
                      <div style={{ fontSize: "0.75rem", color: "#991B1B", fontWeight: "600" }}>Void Amount</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#7F1D1D" }}>
                        {currencyFormatter.format(Number(selectedStore.data?.totalVoidAmount || 0))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div
                      style={{
                        padding: "12px 16px",
                        background: "#FEE2E2",
                        borderRadius: "10px",
                        border: "1px solid #FECACA",
                      }}
                    >
                      <div style={{ fontSize: "0.75rem", color: "#991B1B", fontWeight: "600" }}>Void Count</div>
                      <div style={{ fontSize: "1.125rem", fontWeight: "700", color: "#7F1D1D" }}>
                        {Number(selectedStore.data?.totalVoidCount || 0).toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportTable;
